import { Injectable } from '@angular/core';
import { InjectableMapDataStateService } from '@ui/shared/domain-map';
import type { ProjectListItemModel } from '../definitions/project-list-item.model';
import type { ProjectListFilterKey } from '../types/project-list-filters';

@Injectable({ providedIn: 'root' })
export class ProjectListMapDataService extends InjectableMapDataStateService<ProjectListItemModel, ProjectListFilterKey> {
}
